import {
  Canvas,
  useThree,
  useFrame,
} from "@react-three/fiber";

import {
  useGLTF,
  OrbitControls,
} from "@react-three/drei";

import * as THREE from "three";

import {
  Suspense,
  useRef,
} from "react";

import {
  Box,
} from "@mui/material";

function Model(props) {
  const { scene } = useGLTF(props.url);

  return <primitive
    ref={props.ref}
    object={scene}
  />;
};

function HandleCompassPosition({
  wellbore3DRef,
  orbitControlRef,
  mainOrbitControlRef,
}) {
  const { scene, camera } = useThree();
  useFrame(() => {
    if (camera !== undefined && scene?.children !== undefined) {
      // console.log(orbitControlRef);
      // console.log(mainOrbitControlRef);

      if (
        orbitControlRef?.current !== undefined &&
        mainOrbitControlRef?.current !== undefined &&
        wellbore3DRef?.current?.camera !== undefined
      ) {
        const newPosition = new THREE.Vector3().subVectors(
          wellbore3DRef?.current?.camera?.position,
          mainOrbitControlRef?.current?.target
        )?.normalize()?.multiplyScalar(9)?.toArray();

        camera?.position?.fromArray(
          newPosition
        )
        orbitControlRef?.current?.position?.fromArray(
          newPosition
        );

        for (const element of scene?.children) {
          if (element.type === "Group") {
            element.rotation.set(0, -Math.PI / 2, 0);
          };
        };
      }
    };
  });
};

export default function RTFO3DCompass({
  wellbore3DRef,
  darkMode,
  mainOrbitControlRef,
}) {
  const orbitControlRef = useRef();

  try {
    return (
      <Box
        sx={{
          position: "absolute",
          bottom: "5%",
          right: "10px",
          width: "10%",
          aspectRatio: 1 / 1
        }}
      >
        <Canvas
          style={{
            height: "100%", width: "100%", borderRadius: "50%"
          }}
        >
          <HandleCompassPosition
            wellbore3DRef={wellbore3DRef}
            orbitControlRef={orbitControlRef}
            mainOrbitControlRef={mainOrbitControlRef}
          />
          <OrbitControls
            ref={orbitControlRef}
            enableRotate={false}
            enableDamping={false}
            enableZoom={false}
            enablePan={false}
          />
          <color attach="background" args={[darkMode ? "black" : "white"]} />
          <Suspense>
            <Model
              url={process.env.PUBLIC_URL + darkMode ? '/assets3D/compass3D_white.glb' : '/assets3D/compass3D.glb'}
            />
            <ambientLight intensity={0.5} />
            <directionalLight position={[2, 5, 2]} intensity={1} />
          </Suspense>
        </Canvas>
      </Box>
    );
  } catch (err) {
    console.log(err)
  };
};
